const products = (() => {

    const initBlock = el => {
        const filtersWrapper = el.querySelector('[data-products-filters]');
        filtersWrapper.querySelectorAll('[name="productType"]').forEach(cb => {
            cb.addEventListener('click', () => {
                handleFilter(el, "1");
            });
        });
        paging.handlePaging(el, handleFilter);
       // document.querySelectorAll('[data-enquiry-button]').forEach(el => enquiry.handleAddClick(el));
        toggleFilters(el);
    };
    
    const toggleFilters = el => {
        const filtersWrapper = el.querySelector('[data-products-filters]');
        el.querySelectorAll('[data-open-filters]').forEach(openToggle => {
            openToggle.addEventListener('click', () => {
                filtersWrapper.setAttribute('open', '');
            });
        });
        el.querySelectorAll('[data-close-filters]').forEach(closeToggle => {
            closeToggle.addEventListener('click', () => {
                filtersWrapper.removeAttribute('open');
            });
        });
    };

    const handleFilter = (el, pageId) => {
        const filtersWrapper = el.querySelector('[data-products-filters]');
        const nodeId = filtersWrapper.dataset.nodeid;
        const pageSize = filtersWrapper.dataset.pagesize;
        let filters = [];
        filtersWrapper.querySelectorAll('[name="productType"]').forEach(cb => {
            if (cb.checked) {
                filters.push(cb.value);
            }
        });
        let resultsWrapper = el.querySelector('[data-products-results]');
        let countWrappers = el.querySelectorAll('[data-total-display]');
        fetch(`/umbraco/surface/products/get?nodeId=${nodeId}&filters=${filters}&pageSize=${pageSize}&pageId=${pageId}`)
            .then(response => response.text())
            .then(data => {
                if (resultsWrapper && data){
                    resultsWrapper.outerHTML = data;
                    resultsWrapper = el.querySelector('[data-products-results]');
                    countWrappers.forEach(countWrapper => countWrapper.innerHTML = resultsWrapper.dataset.totalCount);
                    const activeFilters = filtersWrapper.querySelector('[data-active-filters]');
                    activeFilters.innerHTML = '';
                    const closeIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 9 10" fill="none">
                                                <path d="M6.21289 4.98828L8.55664 7.35547C8.86133 7.63672 8.86133 8.10547 8.55664 8.38672L8.04102 8.90234C7.75977 
                                                9.20703 7.29102 9.20703 7.00977 8.90234L4.66602 6.55859L2.29883 8.90234C2.01758 9.20703 1.54883 9.20703 1.26758 
                                                8.90234L0.751953 8.38672C0.447266 8.10547 0.447266 7.63672 0.751953 7.35547L3.0957 4.98828L0.751953 2.64453C0.447266 
                                                2.36328 0.447266 1.89453 0.751953 1.61328L1.26758 1.09766C1.54883 0.792969 2.01758 0.792969 2.29883 1.09766L4.66602 
                                                3.44141L7.00977 1.09766C7.29102 0.792969 7.75977 0.792969 8.04102 1.09766L8.55664 1.61328C8.86133 1.89453 8.86133 
                                                2.36328 8.55664 2.64453L6.21289 4.98828Z" fill="#333333"/></svg>`;
                    filtersWrapper.querySelectorAll('[name="productType"]:checked').forEach(cb => {
                        activeFilters.innerHTML += `<div class="text-xs font-semibold text-websiteGrey flex justify-between items-center gap-x-2 px-2 py-1 border border-websiteBlue cursor-pointer" data-active-filter="${cb.value}" data-label="${cb.dataset.label}">${cb.dataset.label}${closeIcon}</div>`;
                    });
                    const activeFiltersCount = el.querySelector('[data-active-filters-count]');
                    activeFiltersCount.innerHTML = activeFilters.querySelectorAll('[data-active-filter]').length;
                    filtersWrapper.querySelectorAll('[data-active-filter]').forEach(cb => {
                        cb.addEventListener('click', () => {
                            const checkboxItem = filtersWrapper.querySelector(`input[value="${cb.dataset.activeFilter}"]`);
                            if (checkboxItem){
                                checkboxItem.checked = false;
                                handleFilter(el, "1");
                            }
                        });
                    });
                    filtersWrapper.querySelectorAll('[data-clear-active]').forEach(clear => {
                        clear.addEventListener('click', () => {
                            activeFilters.innerHTML = '';
                            filtersWrapper.querySelectorAll('[name="productType"]:checked').forEach(cb => {
                                cb.checked = false;
                            });
                            handleFilter(el, "1");
                        });
                    });
                    paging.handlePaging(el, handleFilter);
                    document.querySelectorAll('[data-enquiry-button]').forEach(el => enquiry.handleAddClick(el));
                }
            })
            .catch(_ => {});
    }

    return {initBlock};
})();
document.querySelectorAll('[data-products]').forEach(el => products.initBlock(el));